import { useABTest } from "../../queries/users/useABTest";
import { useDeviceLang } from "../../hooks/deviceHooks";
import { useViewerDecks } from "../../queries/viewerQuery";
import { langs } from "../../sharedJs__generated/langsList";
import { useTranslates } from "../../hooks/useTranslates";

export function usePaywallTitle() {
  const paywallTitleAbTest = useABTest("abtest_paywallTitle");
  const { appLang } = useDeviceLang();
  const { deck } = useViewerDecks();

  const targetLanguageCode = deck?.front;
  const targetLanguage = targetLanguageCode ? langs[targetLanguageCode]?.label : undefined;

  const shouldSkipTranslate = !paywallTitleAbTest || !targetLanguage;
  const { translates, isLoadingTranslates } = useTranslates(
    appLang,
    // × used because x is replaced with word in translation
    [`Learn ${targetLanguage} 2.3× faster!`],
    shouldSkipTranslate
  );

  let title = translates && translates.length > 0 ? translates[0] : undefined;
  title = title?.replace("×", "x");

  return { title, isLoading: isLoadingTranslates, isAbTestEnabled: !!paywallTitleAbTest };
}
